import {ApiService} from '@/services/ApiService'

const URL = '/api/info-bubble'

class InfoService extends ApiService {
    constructor(){
        super()
    }
    getUrl(){
        return URL
    }
}

export default new InfoService()